import { IApiRes } from "../../../types/interfaces";

export interface IProjectApiResponse<T> {
    status: number;
    message_key: string;
    message: string;
    data: {
        data: T;
    };
}

export interface IProjectInput {
    title: string;
    description: string;
    image_url: string | null;
    id: string;
    max_context_token: number;
    max_history_token: number;
    max_resp_token: number;
    min_embed_score: number;
    top_k: number;
    classify_category_tags: { tag: string }[];
}

export interface IInitProjectReq {
    project_title?: string;
    knowledge_list: string[];
}

export interface IInitProjectInput {
    project_title: string;
}

export enum ProjectVersion {
    V1 = "v1",
    V2 = "v2",
}

export interface IProjectTypes {
    id: string;
    code: string;
    title: string;
    image_url?: string;
    background_image_url: string;
    description: string;
    creator_id: string;
    creator?: string;
    created_at: string;
    updated_at: string;
    max_context_token?: number;
    max_history_token?: number;
    max_resp_token?: number;
    min_embed_score?: number;
    top_k?: number;
    version?: ProjectVersion;
    classify_category?: string | null;
}

export interface ICreateProjectReq {
    title: string;
    image_url: string;
    description: boolean;
}

export interface ICreateProjectRes extends IApiRes {
    data: string; // > API will response new project id
}
export interface IUpdateProjectReq {
    id: string;
    title: string;
    image_url: string | null;
    description: string;
    classify_category?: string;
}

export interface IDeleteProjectReq {
    id: string;
}

export interface IQueryProjectParams {
    id: string | undefined;
}
export interface IDownloadPictureReq {
    project_id: string;
    start_time: string;
    end_time: string;
}
export interface IDownloadPictureRes {
    message: string;
    status: string;
    zip_url: string;
}
export interface IDownloadExcelReq {
    project_uuid: string;
    project_name: string;
    start_time: string;
    end_time: string;
}
export interface IGetProjectPhotosReq {
    project_id: string;
    start_time: string;
    end_time: string;
}
export interface IDownloadExcelReq {
    project_uuid: string;
    project_name: string;
    start_time: string;
    end_time: string;
}
type ClickUsage = {
    name: string;
    category: string;
    event: string;
    lang: string;
    param_1: string;
    param_2: string;
    param_3: string;
    count: number;
};
type GPTQAList = {
    name: string;
    source: string;
    question: string;
    answer: string;
    q_lang: string;
    a_lang: string;
    qa_category: string;
    completion_tokens: number;
    prompt_tokens: number;
    total_tokens: number;
    created_at: Date;
};

type TTSUsage = {
    name: string;
    system: string;
    source: string;
    speech_text: string;
    word_count: number;
    created_at: string;
};

type Satisfaction = {
    rating: string;
    liked: string;
    comment: string;
    user_query: string;
    ai_response: string;
    created_at: string;
};

export interface IDownloadExcelRes {
    click_usage_list: ClickUsage[];
    take_photo_list: null;
    gpt_qa_list: GPTQAList[];
    tts_usage_list: TTSUsage[];
    satisfaction: Satisfaction[];
}

export interface IExportUsageReportRes {
    status: number;
    message_key: string;
    message: string;
    data: IDownloadExcelRes;
}
